import { PriceUtils } from '@wix/bookings-uou-mappers';
import { SelectedVariants } from '@wix/bookings-uou-types';
import { TFunction } from '../../../../types/types';
import { SlotService } from '../../../state/types';

export const getPriceLineText = ({
  slotService,
  dateRegionalSettingsLocale,
  t,
  selectedVariant,
  totalNumberOfParticipants = 1,
}: {
  slotService: SlotService;
  dateRegionalSettingsLocale: string;
  t: TFunction;
  selectedVariant?: SelectedVariants;
  totalNumberOfParticipants?: number;
}) => {
  const { paymentDetails } = slotService;

  let priceText = '';

  if (selectedVariant) {
    priceText = `${PriceUtils.getFormattedCurrency({
      price: Number(paymentDetails.price),
      currency: paymentDetails.currency,
      locale: dateRegionalSettingsLocale,
    })}${selectedVariant?.choices?.[0].custom
      ? ` (${selectedVariant?.choices?.[0].custom})`
      : ''
      }${totalNumberOfParticipants > 1
        ? ' ' +
        t(
          'app.bookings-form.service-details.dynamic-price.number-of-participants',
          { numberOfParticipants: selectedVariant?.numberOfParticipants },
        )
        : ''
      }`;
  } else {
    const price = PriceUtils.getFormattedCurrency({
      price: paymentDetails.minPrice?.price!,
      currency: paymentDetails.currency,
      locale: dateRegionalSettingsLocale,
    });

    if (
      paymentDetails.isVariedPricing ||
      Number(paymentDetails.minPrice?.price)
    ) {
      priceText =
        paymentDetails.isVariedPricing &&
          !slotService?.dynamicPriceInfo?.selectedPreferences?.length
          ? t('app.payment.from-price.text', { price })
          : price;

      if (totalNumberOfParticipants > 1) {
        priceText = `${priceText} ${t(
          'app.bookings-form.service-details.dynamic-price.number-of-participants',
          { numberOfParticipants: totalNumberOfParticipants },
        )}`;
      }
    }

    if (paymentDetails.isFree) {
      if (paymentDetails.priceText) {
        priceText = paymentDetails.priceText;
      } else {
        priceText = t('app.bookings-form.service-details.free-service');
      }
    }
  }

  if (paymentDetails.minCharge) {
    priceText = `${priceText} (${t('app.payment.summary.deposit.text', {
      price: PriceUtils.getFormattedCurrency({
        price: paymentDetails.minCharge,
        currency: paymentDetails.currency,
        locale: dateRegionalSettingsLocale,
      }),
    })})`;
  }

  return priceText;
};
